import Head from 'next/head';
import { ThemePage } from '@/components/themes/ThemePage';
import { ThemeInitiatives } from '@/components/themes/ThemeInitiatives';
import { ThemeEntities } from '@/components/themes/ThemeEmtities';

const PETS_SUB_CATEGORIES = [
  {
    title: 'Pet Store Sampling',
    description:
      'In-store demos and treat sampling at pet specialty retailers, pet warehouses, and independent pet shops.',
  },
  {
    title: 'Vet Clinic Partnerships',
    description:
      'Product placements, sample packs, and brand activations in veterinary clinics and animal hospitals.',
  },
  {
    title: 'Dog Park & Trail Events',
    description:
      'Pop-up sampling and brand activations at dog parks, walking trails, and off-leash areas.',
  },
  {
    title: 'Pet Expos & Shows',
    description:
      'Brand presence at pet expos, breed shows, agility competitions, and animal welfare fundraisers.',
  },
  {
    title: 'Shelters & Rescue Partnerships',
    description:
      'Brand sponsorships and product donations for animal shelters, rescue organisations, and adoption events.',
  },
  {
    title: 'Brand Collaborations',
    description:
      'Joint giveaways, co-branded bundles, and cross-promotions between complementary pet brands — combining products that genuinely belong together to reach aligned audiences.',
  },
];

export default function PetsThemePage() {
  return (
    <>
      <Head>
        <title>Pets | Sizzle</title>
        <meta
          name="description"
          content="Pet food sampling, vet clinic activations, dog park events, and brand partnerships for the pet industry."
        />
      </Head>
      <ThemePage
        breadcrumbs={[{ label: 'Themes', href: '/themes' }, { label: 'Pets' }]}
        title="Pets & animal care"
        description="Connect pet food, treat, and wellness brands with pet owners where they already are — vet clinics, dog parks, pet stores, and expos. Drive trial with the people (and pets) who matter most."
        heroImage=""
        subCategoriesTitle="Reach pet owners everywhere"
        subCategoriesSubtitle="From vet waiting rooms to dog park pop-ups — find the right moment to get your product in front of pet parents."
        subCategories={PETS_SUB_CATEGORIES}
      >
        <ThemeInitiatives
          title="Featured Initiatives"
          subtitle="Pet-related initiatives from brands and partners."
          categories={['trade']}
          limit={6}
          themes={['pets']}
        />

        <ThemeEntities
          title="Featured Brands and Businesses"
          subtitle="Pet-related brands and businesses."
          roles={['brand', 'supplier']}
          limit={8}
          themes={['pets']}
        />
      </ThemePage>
    </>
  );
}
